import { LicenseInfo } from '@mui/x-license';

const licenseKey =
  '456aa11fbcb2122b74f768ad89d395a9Tz0xMjQyOTksRT0xODAwMDU3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';

LicenseInfo.setLicenseKey(licenseKey);

export default function MuiXLicense() {
  return null;
}
